import MovieSearch from "./components/MovieSearch";

function App() {
  return (
    <div className="App">
      <MovieSearch />
    </div>
  );
}

export default App;
